import { MouseEvent, useState } from 'react'
import CommonLayout from '../../../layouts/Common'
import { ModalContentWrapper, MyInfoWrapper, StyledButton, StyledCard, StyledCollapse } from './style'
import BioInfo from '../../../components/Forms/Bio/Info'
import ContactDetailsInfo from '../../../components/Forms/ContactDetails/Info'
import CommonInfo from '../../../components/Forms/Common/Info'
import { bloodlineDiseases, medications, surgeries, vaccinations } from '../../../constants/dummy_data/client'
import ImportantNotesInfo from '../../../components/Forms/ImportantNotes/Info'
import { Modal } from 'antd'
import BioForm from '../../../components/Forms/Bio'
import ContactDetailsForm from '../../../components/Forms/ContactDetails'
import AllergiesAndOthersForm from '../../../components/Forms/AllergiesAndOthers'
import SpecialistsForm from '../../../components/Forms/Specialists'
import MedicationsForm from '../../../components/Forms/Medications'
import VaccinationsForm from '../../../components/Forms/Vaccinations'
import BloodlineDiseasesForm from '../../../components/Forms/BloodlineDiseases'
import SurgeriesForm from '../../../components/Forms/Surgeries'
import ImportantNotesForm from '../../../components/Forms/ImportantNotes'
import { useParams } from 'react-router-dom'
import { useGetProfessionalClient } from '../../../hooks/professionals/useProfessionalClient'
import { useSelector } from 'react-redux'
import { RootState } from '../../../redux/store'
import AllergiesAndOthersInfo from '../../../components/Forms/AllergiesAndOthers/Info'
import FirstMenstruationCycle from '../../../components/Forms/FirstMenstruationCycle/Info'
import FirstMenstruationCycleForm from '../../../components/Forms/FirstMenstruationCycle'
import SpecialistsInfo from '../../../components/Forms/Specialists/Info'
import MedicationsInfo from '../../../components/Forms/Medications/Info'
import VaccinationInfo from '../../../components/Forms/Vaccinations/Info'
import BloodlineDiseasesInfo from '../../../components/Forms/BloodlineDiseases/Info'
import SurgeriesInfo from '../../../components/Forms/Surgeries/Info'

const ClientInfo = () => {
  const { code, clientId } = useParams();
  const { selectedClient } = useSelector((state: RootState) => state.professionals);
  const { data: client, refetch: refetchClient } = useGetProfessionalClient(clientId as string);
  const [modalContent, setModalContent] = useState({
    isOpen: false,
    component: <></>
  });

  console.log('client', selectedClient);

  const onEdit = (e: MouseEvent<HTMLButtonElement>, formTitle: string) => {
    e.stopPropagation();
    let modalContent = {
      component: <></>
    };
    switch (formTitle) {
      case 'bio':
        modalContent.component = <BioForm />;
        break;
      case 'contact_details':
        modalContent.component = <ContactDetailsForm />;
        break;
      case 'allergies_and_others':
        modalContent.component = <AllergiesAndOthersForm />;
        break;
      case 'first_menstruation_cycle':
        modalContent.component = <FirstMenstruationCycleForm />;
        break;
      case 'specialists':
        modalContent.component = <SpecialistsForm />;
        break;
      case 'medications':
        modalContent.component = <MedicationsForm />;
        break;
      case 'vaccinations':
        modalContent.component = <VaccinationsForm />;
        break;
      case 'bloodline_diseases':
        modalContent.component = <BloodlineDiseasesForm />;
        break;
      case 'surgeries':
        modalContent.component = <SurgeriesForm />;
        break;
      case 'important_notes':
        modalContent.component = <ImportantNotesForm />;
        break;
      default:
    };
    setModalContent({
      isOpen: true,
      ...modalContent
    });
  };

  const handleBack = () => {
    setModalContent({
      isOpen: false,
      component: <></>
    });
  }

  return (
    <CommonLayout title="General client info" width="800px">
      <MyInfoWrapper>
        <StyledCollapse
          ghost
          items={[{
            key: '1',
            label: 'Bio',
            children: <BioInfo />,
            extra: <StyledButton
              onClick={(e: MouseEvent<HTMLButtonElement>) => onEdit(e, 'bio')}
              shape="circle"
              type="primary"
              size="small"
              icon={<i className="material-icons-round" style={{ fontSize: '16px' }}>edit</i>}
            />
          }]}
        />
        <StyledCard>
          <p>Email</p>
          <span>{selectedClient?.email}</span>
        </StyledCard>
        <StyledCollapse
          ghost
          items={[{
            key: '1',
            label: 'Contact Details',
            children: <ContactDetailsInfo />,
            extra: <StyledButton
              onClick={(e: MouseEvent<HTMLButtonElement>) => onEdit(e, 'contact_details')}
              shape="circle"
              type="primary"
              size="small"
              icon={<i className="material-icons-round" style={{ fontSize: '16px' }}>edit</i>}
            />
          }]}
        />
        <StyledCollapse
          ghost
          items={[{
            key: '1',
            label: 'Allergies and others',
            children: <AllergiesAndOthersInfo />,
            extra: <StyledButton
              onClick={(e: MouseEvent<HTMLButtonElement>) => onEdit(e, 'allergies_and_others')}
              shape="circle"
              type="primary"
              size="small"
              icon={<i className="material-icons-round" style={{ fontSize: '16px' }}>edit</i>}
            />
          }]}
        />
        <StyledCollapse
          ghost
          items={[{
            key: '1',
            label: 'First Menstruation Cycle',
            children: <FirstMenstruationCycle />,
            extra: <StyledButton
              onClick={(e: MouseEvent<HTMLButtonElement>) => onEdit(e, 'first_menstruation_cycle')}
              shape="circle"
              type="primary"
              size="small"
              icon={<i className="material-icons-round" style={{ fontSize: '16px' }}>edit</i>}
            />
          }]}
        />
        <StyledCollapse
          ghost
          items={[{
            key: '1',
            label: 'Specialists',
            children: <SpecialistsInfo />,
            extra: <StyledButton
              onClick={(e: MouseEvent<HTMLButtonElement>) => onEdit(e, 'specialists')}
              shape="circle"
              type="primary"
              size="small"
              icon={<i className="material-icons-round" style={{ fontSize: '16px' }}>edit</i>}
            />
          }]}
        />
        <StyledCollapse
          ghost
          items={[{
            key: '1',
            label: 'Medications',
            children: <MedicationsInfo />,
            extra: <StyledButton
              onClick={(e: MouseEvent<HTMLButtonElement>) => onEdit(e, 'medications')}
              shape="circle"
              type="primary"
              size="small"
              icon={<i className="material-icons-round" style={{ fontSize: '16px' }}>edit</i>}
            />
          }]}
        />
        <StyledCollapse
          ghost
          items={[{
            key: '1',
            label: 'Vaccinations',
            children: <VaccinationInfo />,
            extra: <StyledButton
              onClick={(e: MouseEvent<HTMLButtonElement>) => onEdit(e, 'vaccinations')}
              shape="circle"
              type="primary"
              size="small"
              icon={<i className="material-icons-round" style={{ fontSize: '16px' }}>edit</i>}
            />
          }]}
        />
        <StyledCollapse
          ghost
          items={[{
            key: '1',
            label: 'Bloodline Diseases',
            children: <BloodlineDiseasesInfo />,
            extra: <StyledButton
              onClick={(e: MouseEvent<HTMLButtonElement>) => onEdit(e, 'bloodline_diseases')}
              shape="circle"
              type="primary"
              size="small"
              icon={<i className="material-icons-round" style={{ fontSize: '16px' }}>edit</i>}
            />
          }]}
        />
        <StyledCollapse
          ghost
          items={[{
            key: '1',
            label: 'Surgeries',
            children: <SurgeriesInfo />,
            extra: <StyledButton
              onClick={(e: MouseEvent<HTMLButtonElement>) => onEdit(e, 'surgeries')}
              shape="circle"
              type="primary"
              size="small"
              icon={<i className="material-icons-round" style={{ fontSize: '16px' }}>edit</i>}
            />
          }]}
        />
        <StyledCollapse
          ghost
          items={[{
            key: '1',
            label: 'Important notes',
            children: <ImportantNotesInfo />,
            extra: <StyledButton
              onClick={(e: MouseEvent<HTMLButtonElement>) => onEdit(e, 'important_notes')}
              shape="circle"
              type="primary"
              size="small"
              icon={<i className="material-icons-round" style={{ fontSize: '16px' }}>edit</i>}
            />
          }]}
        />
      </MyInfoWrapper>
      <Modal
        title="Edit General client info"
        open={modalContent.isOpen}
        onOk={handleBack}
        onCancel={handleBack}
        footer={null}
        width={900}
      >
        <ModalContentWrapper>
          {modalContent.component}
        </ModalContentWrapper>
      </Modal>
    </CommonLayout>
  )
}

export default ClientInfo